"use client";

import getGameContainer from "@casino/ui/Games/getGameContainer";
import { useEffect } from "react";

type Params = {
  fiatRate?: number;
  isReady: boolean;
};

// The SDK only reads fiat-rate once at init; the wallet's fiat rate can change
// while the game keeps running, so push updates onto the live <game-container> too.
const useFiatRateSync = ({ fiatRate, isReady }: Params) => {
  useEffect(() => {
    if (fiatRate === undefined) return;
    getGameContainer()?.setAttribute("fiat-rate", String(fiatRate));
  }, [fiatRate, isReady]);
};

export default useFiatRateSync;
